import React from "react";
import { Handle, Position } from "reactflow";
import "./BaseNode.css";

const BaseNode = ({
  data,
  icon = "bi-box",
  color = "#888888",
  label = "Node",
  subtitle = null,
  // compatível com o antigo (top/bottom) e o novo (left/right)
  hasHandles = { left: true, right: true },
  selected = false,
}) => {
  const iconClass = icon.includes("bi ") ? icon : `bi ${icon}`;

  // Fallback: se alguém ainda passar top/bottom, converte pra left/right
  const leftEnabled =
    typeof hasHandles.left === "boolean"
      ? hasHandles.left
      : Boolean(hasHandles.top);

  const rightEnabled =
    typeof hasHandles.right === "boolean"
      ? hasHandles.right
      : Boolean(hasHandles.bottom);

  return (
    <div
      className={`workflow-node-wrap ${selected ? "workflow-node-wrap--selected" : ""}`}
      style={{ "--node-color": color }}
      title={label}
    >
      {/* Handle ESQUERDA: entrada (target) */}
      {leftEnabled && (
        <Handle
          type="target"
          position={Position.Left}
          className="workflow-node__handle workflow-node__handle--left"
        />
      )}

      {/* Quadrado do node (somente ícone) */}
      <div className="workflow-node-box">
        <span className="workflow-node__icon-badge" aria-hidden="true">
          <i className={iconClass} />
        </span>
      </div>

      {/* Nome FORA (sempre visível) */}
      <div className="workflow-node-meta">
        <div className="workflow-node__label">{label}</div>
        {subtitle ? <div className="workflow-node__subtitle">{subtitle}</div> : null}
      </div>

      {/* Handle DIREITA: saída (source) */}
      {rightEnabled && (
        <Handle
          type="source"
          position={Position.Right}
          className="workflow-node__handle workflow-node__handle--right"
        />
      )}
    </div>
  );
};

export default BaseNode;
